<template>
  <div>
    <div v-show="showMain" class="text-left">
      <data-table :clickHandler="openUser"
                  :columns="columns"
                  add-label="Add new User"
                  show-add-button
                  :add-handler="newUser"
                  :dataSource="'/affiliate/listUsers/' + this.affiliate.id"
                  pageTitle="Brands/Affiliate Access"/>
    </div>

    <div v-if="showUser && currentUser">
      <mdb-card>
        <mdb-card-body class="text-left">
          <mdb-input v-model="currentUser.email" :disabled="currentUser.id != null" label="Email"/>
          <mdb-input v-model="currentUser.name" disabled v-show="currentUser.id != null" label="Name"/>
          <div class="form-check">
            <input aria-label="Edit landing page?" class="form-control form-check-input" id="editLandingPage" type="checkbox"
                   v-model="currentUser.editLandingPage"/>
            <label for="editLandingPage">May edit landing page</label>
          </div>
          <div class="form-check">
            <input aria-label="User Maintenance?" class="form-control form-check-input" id="userMaint" type="checkbox"
                   v-model="currentUser.userMaint"/>
            <label for="userMaint">May control user access</label>
          </div>
          <div class="form-check">
            <input aria-label="Is Admin in all Groups" class="form-control form-check-input" id="allGroupsAdmin" type="checkbox"
                   v-model="currentUser.allGroupsAdmin"/>
            <label for="allGroupsAdmin">Is admin in all child groups?</label>
          </div>

          <mdb-btn icon="save" color="success" @click="saveUser">Save</mdb-btn>
          <mdb-btn icon="minus-circle" color="danger" @click="cancelShow">Cancel</mdb-btn>
        </mdb-card-body>
      </mdb-card>

    </div>

    <div class="text-left">
      <mdb-btn icon="database" @click="cancelMaint">Home</mdb-btn>
    </div>
    <yes-no-modal v-if="yesNoModal" @yes="deleteGlobalGroup" @no="yesNoModal=false"/>
  </div>

</template>

<script>
import dataTable from '../common/DataTable'
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";
import YesNoModal from "../common/YesNoModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
} from 'mdbvue';

export default {
  name: 'group-branding-access',
  components: {
    Avatar,
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbRow,
    mdbCol,
    dataTable,
    YesNoModal
  },
  props: {
    affiliate: {
      type: Object,
      default: null
    }
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      columns: [
        {label: "", field: "avatar", type: "avatar"},
        {label: "Email", field: "email"},
        {label: "Edit Landing Page", field: "editLandingPage", type:"checkbox"},
        {label: "Maintain Users", field: "userMaint", type:"checkbox"},
        {label: "All Groups Admin", field: "allGroupsAdmin", type:"checkbox"}
      ],
      currentUser: null,
      showUser: false,
      showMain: true,
      changeGlobalGroupModal: false,
      yesNoModal: false
    }
  },
  methods: {
    cancelMaint: function () {
      this.$emit("cancel")
    },
    saveUser: function() {
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/user/" + this.affiliate.id, this.currentUser).then(
        (results) => {
          this.$store.dispatch("setDataTableReload", true)
          this.showMain = true
          this.showUser = false
          this.currentUser = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    newUser: function () {
      this.currentUser = {
        id: null,
        name: "",
        email: "",
        editLandingPage: false,
        userMaint: false,
        allGroupsAdmin: false
      }
      this.showMain = false
      this.showUser = true
    },
    cancelShow: function () {
      this.showMain = true
      this.currentUser = null
      this.showUser = false
    },

    openUser: function (row) {
      this.showMain = false
      this.currentUser = JSON.parse(JSON.stringify(row))
      this.showUser = true
    },
    deleteGlobalGroup(group) {
      this.yesNoModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete("/affiliate/globalGroup/" + this.currentBrand.id).then(
        (results) => {
          this.currentBrand.globalGroupId = null
          this.currentBrand.globalGroupName = null
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/settings/", this.currentBrand).then(
        (results) => {
          this.$notify.success({message: "Saved", timeOut: 3000})
          if (!this.currentBrand.id) {
            this.currentBrand.id = results.data.id
            this.currentBrand.primaryOwnerId = results.data.primaryOwnerId
            this.currentBrand.primaryOwnerName = results.data.primaryOwnerName
            this.currentBrand.primaryOwnerAvatar = results.data.primaryOwnerAvatar
            this.$store.dispatch("setDataTableReload", true)
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
